import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { CalendarDatePicker, TutorialContainer } from "../../../_components";

export function ChronicleStartPage({ onSubmit, store, formRef, getCalendar }) {
  const [calendar, setCalendar] = useState(null);
  const { control, handleSubmit } = useForm({
    defaultValues: {
      startDate: store.startDate || "0",
    },
  });

  useEffect(() => {
    const newCalendar = getCalendar(store);
    console.log(newCalendar);
    setCalendar(newCalendar);
  }, []);
  return (
    <div className="chronos-chronicle-start-page">
      {/* GIF */}
      <TutorialContainer
        type="video"
        url="https://wa-cdn.nyc3.cdn.digitaloceanspaces.com/chronos/cc6f1e8d-375b-40bd-b040-15f1ecd3356a.webm"
      />
      <form onSubmit={handleSubmit(onSubmit)} ref={formRef}>
        <div className="content-page-wrapper">
          <h2 className="chronos-wizard-page-title">
            Select Initialization Date
          </h2>
          <p className="chronos-wizard-text">
            This is the date that your chronicle displays when it's first
            loaded.
          </p>
          <p className="chronos-wizard-text">
            This is NOT the beginning of your timeline, and you can add timeline
            events before this date.
          </p>

          {calendar !== null && (
            <div className="form-group">
              <Controller
                control={control}
                name="startDate"
                id="startDate"
                render={({ value, onChange }) => (
                  <CalendarDatePicker
                    calendar={calendar}
                    onChange={onChange}
                    value={value}
                    showSpacer
                  />
                )}
              />
            </div>
          )}
        </div>
      </form>
    </div>
  );
}
